import { observer } from 'mobx-react'

import { FiltersSharedProps } from '@avantstay/backoffice-core'

import { storeHolder } from '@new/__global/components/FastTapeChart/stores/TapeChartStore'
import { SelectBasedField } from '@new/__global/components/Filters/FiltersVariations/Select'

import { UnassignedBookingsView } from '../../config/contants'
import { HotelTapeChartFiltersStore } from '../../stores/HotelTapeChartFiltersStore'

interface UnassignedBookingsFilterProps extends FiltersSharedProps {
  onChange: (value?: string) => void
}

const getOptions = (hasRoomType: boolean) => {
  const disabledOption = { label: 'Disabled', value: UnassignedBookingsView.Disabled }
  const overlayOption = { label: 'Overlay', value: UnassignedBookingsView.Overlay }

  if (hasRoomType) {
    return [
      disabledOption,
      { label: 'List', value: UnassignedBookingsView.List },
      overlayOption,
      { label: 'List & Overlay', value: UnassignedBookingsView.ListAndOverlay },
    ]
  }

  return [disabledOption, overlayOption]
}

const _UnassignedBookingsFilter = (props: UnassignedBookingsFilterProps) => {
  const filterStore = storeHolder.store.filterStore as HotelTapeChartFiltersStore

  const options = getOptions(!!filterStore.roomTypeId)

  return (
    <SelectBasedField
      title=""
      groupId="unassigned-bookings-filter"
      inputTitle="Unassigned Bookings"
      inputWidth={130}
      isSearchable={false}
      initialValue={filterStore.unassignedBookingsView?.value}
      options={options}
      {...props}
    />
  )
}

export const UnassignedBookingsFilter = observer(_UnassignedBookingsFilter)
